import styled from 'styled-components';
import Button from '@carvana/showroom-forms/Button/Primary';
import { SecondaryButton } from '@carvana/showroom-forms';
import NativeLink from '../../common/NativeLink';

const AutopayTermsCardWrapper = styled.div`
  align-content: center;
  border: 1px solid #d9dde9;
  border-radius: 8px;
  background-color: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  width: 100%;
  height: 100%;
  margin: 0 auto;
  max-width: 912px;
  color: #6d7184;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 325px;
    justify-content: flex-start;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-height: 410px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    min-height: auto;
    padding: 32px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xl}px) {
    min-height: 320px;
  }
`;

const AutopayTermsTitle = styled.h2`
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0 0 24px;
  margin: 0 auto;
  font-size: 20px;
  line-height: 24px;
  max-width: 912px;
`;

const HR = styled.hr`
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  width: 100%;
  border-bottom-color: transparent;
`;

const Section = styled.div`
  text-align: left;
  margin: 15px 0;
`;

const Paragraph = styled.p`
  ${(props) => props.theme.font.subhead.v400};
  font-weight: 400;
  line-height: 1.6;
`;

const Title = styled.h2`
  ${(props) => props.theme.font.heading.v100};
  align-self: center;
  text-align: center;
  text-transform: uppercase;
  line-height: 1.6;
`;

const Heading = styled.h3`
  ${(props) => props.theme.font.heading.v500};
  margin: 32px 0 24px 0;
  color: #6d7184;
  text-transform: uppercase;
  line-height: 1.6;
`;

const SubHeading = styled.span`
  ${(props) => props.theme.font.subhead.v400};
  color: #6d7184;
  font-weight: ${(props) => props.theme.font.weight.v300};
`;

const CheckboxWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: baseline;
`;

const LabelWrapper = styled.p`
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: ${(props) => props.theme.font.weight.v200};
  ${(props) => props.theme.font.body.v300};
  max-width: 630px;
`;

const EnrollButton = styled(Button)`
  margin: 0 15px;
  width: 250px;
  height: 55px;

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    width: 100%;
  }
`;
const EnrollAndSaveButton = styled(SecondaryButton)`
  background: ${(props) => props.theme.color.neutral.v100};
  border-color: ${(props) => props.theme.color.neutral.v500};
  color: ${(props) => props.theme.color.neutral.v500};
  margin: 0 15px;
  width: 250px;
  height: 55px;

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    width: 100%;
  }
`;

const Terms = styled.div`
  padding: 15px;
`;

const HyperLink = styled(NativeLink)`
  color: ${(props) => props.theme.color.primary.v200};
  text-decoration: underline;
`;

export {
  AutopayTermsCardWrapper,
  AutopayTermsTitle,
  HR,
  Section,
  Paragraph,
  Title,
  Heading,
  CheckboxWrapper,
  LabelWrapper,
  EnrollButton,
  EnrollAndSaveButton,
  SubHeading,
  Terms,
  HyperLink,
};
